import { DateEvent } from "../../../types/date";
import { mdiClockOutline } from "@mdi/js";
import { Show } from "solid-js";
import { useDateWidget } from "../../../providers/dates/context";
import { Group } from "~/components/ui/group";
import { Icon } from "~/components/ui/icon";
import { Text } from "~/components/ui/text";

export function TimeElement(props: { event: DateEvent; }) {

	const { formatTime } = useDateWidget();

	return (
		<Show when={props.event}>
			{(event) => (
				<Group gap={1}>
					<Icon path={mdiClockOutline} display="inline" />
					<Text size="sm">
						{formatTime(event())}
					</Text>
				</Group>
			)}
		</Show>
	);
}
